import React from 'react';
import moment from 'moment';
import Rate from '../../Rate';

const CreditorEmailDetails = ({ policy, rate }) => {
	const { policyNumber } = policy;
	const { transactionDate, policyEffectiveDate, policyExpirationDate, email } = rate;
	const { action, vehicle, addressLine1, addressLine2, addressLine3 } = email;
	const { year, make, model } = vehicle;

	return (
		<table>
			<tr>
				<td>Policy Number: {policyNumber}</td>
				<td>
					<div>
						Effective Policy Period: {moment(transactionDate).format('L')} to {moment(policyExpirationDate).format('L')}
					</div>
					<div>
						Current Policy Period: {moment(policyEffectiveDate).format('L')} to {moment(policyExpirationDate).format('L')}
					</div>
				</td>
			</tr>
			<tr>
				<td colSpan='2'>
					<Rate rate={rate} />
				</td>
			</tr>
			<tr>
				<td colSpan='2'>
					Lienholder {action} on {year} {make} {model}
				</td>
			</tr>
			<tr>
				<td colSpan='2'>
					<div>Lienholder Information:</div>
					<div>{addressLine1}</div>
					<div>{addressLine2}</div>
					<div>{addressLine3}</div>
				</td>
			</tr>
		</table>
	);
};

export default CreditorEmailDetails;
